<template>
  <div class="budget-segmentation-container">
    <h3>Segmentação</h3>

    <segmentos-dialog
      v-if="!offerWithSegment"
      :required="false"
      :disable="disableAddSegment"
      single-line
      :selecionados.sync="segments"
      template-type="badge-button"
      btn-text="Adicionar segmentos"
    />

    <div v-if="segments.length" class="d-flex align-center">
      <v-chip-group show-arrows active-class="primary--text">
        <v-chip
          v-for="(segment, index) in segments"
          :key="index"
          :ripple="false"
          :disabled="isMariaCampaignPersonalized || isMariaCampaignActive || isMariaCampaignFinished || offerWithSegment"
        >
          <strong class="pr-2">{{ segment.name }}</strong>
          <v-progress-circular v-if="segment.updating" indeterminate color="primary" size="15" />
          <span v-else>({{ segment.clients_qty | zeroWhenEmpty | localeString }} clientes)</span>
          <mf-icon v-if="isSegmentDeletable" class="ml-2" icon="clear" size="14" color="cinza-d10" @click="segments.splice(index, 1)" />
        </v-chip>
      </v-chip-group>

      <mf-button text color="marca-0-l40" icon="autorenew" label="Atualizar segmento" :disabled="updating || offerWithSegment" @click="updateSegmentsAction" />
    </div>

    <mf-info-card
      v-if="hasSegments && !offerWithSegment"
      icon="warning"
      variant="warning"
      description="Adicionando segmentos nossa IA deixa de sugerir o melhor público para esse grupo de produtos."
      class="mt-3"
      max-width="650px"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import SegmentosDialog from '@/modules/campanhas/views/components/SegmentosDialog.vue'
import { mariaCampaign } from '@/modules/maria/campanha-da-maria-v2/mixins/maria-campaign'

export default {
  name: 'BudgetSegmentation',
  components: { SegmentosDialog },
  filters: {
    zeroWhenEmpty(value) {
      return value || 0
    },
  },
  mixins: [mariaCampaign],
  data: () => ({
    updating: false,
    upToDateSegmemts: true,
  }),
  computed: {
    segments: {
      get() {
        return this.campaign.segments
      },
      set(value) {
        this.setOmniCampaignKey({ key: 'segments', payload: value })
      },
    },
    isSegmentDeletable() {
      if (this.isMariaCampaignPersonalized) return false
      if (this.isMariaCampaignActive) return false
      if (this.isMariaCampaignFinished) return false

      return !this.offerWithSegment
    },
    disableAddSegment() {
      return this.offerWithSegment || this.isMariaCampaignActive || this.isMariaCampaignFinished
    },
  },
  methods: {
    ...mapActions(['updateSegments']),
    updateSegmentsAction() {
      if (this.updating) return
      this.updateSegments(this.segments.map((segment) => segment._id)).catch(() => {
        this.$snackbar({
          message: 'Não foi possível atualizar o segmento, tente novamente mais tarde ou entre em contato com o suporte',
          snackbarColor: 'error',
        })
        this.updating = false
      })
    },
  },
}
</script>

<style lang="scss" scoped>
h3 {
  font-size: 14px;
  font-weight: 700;
  color: $cinza-d10;
  margin-bottom: 12px;
}
</style>
